'use client'
import { urls } from "../urls/Urls";

const NewRequests = () => {
    return (
        <>
            <div>
                <p className="text-3xl flex text-gray-800 font-medium justify-center pt-4">
                    Request Support
                </p>
            </div>
            <div className="flex flex-col md:flex-row gap-8 py-4 items-center justify-center text-gray-800">
                <a
                    href={urls.concur}
                    target="_blank"
                    rel="noreferrer"
                    className="h-auto md:w-1/3 bg-gradient-to-r border border-gray-200 bg-white hover:shadow-md hover:bg-gray-100 hover:border-gray-400 p-2 py-4 px-4 flex max-w-96 rounded drop-shadow"
                >
                    <div className="flex items-center justify-center">
                        <img
                            src={'/concurs.png'}
                            height={150}
                            width={150}
                            className="p-2 px-3"
                            alt="concur"
                        />

                    </div>
                    <div className="">
                        <h2 className="text-2xl font-medium">Concur</h2>
                        <p className="text-sm py-2">Open a ticket to report a problem, update access, add projects or ask a question</p>
                        <p className='text-base'></p>
                    </div>
                </a>


                <a
                    href={urls.facilities}
                    target="_blank"
                    rel="noreferrer"
                    className="h-auto md:w-1/3 bg-gradient-to-r border border-gray-200 bg-white hover:shadow-md hover:bg-gray-100 hover:border-gray-400 p-2 py-4 px-4 flex max-w-96 rounded drop-shadow"
                >
                    <div className="flex items-center justify-center">
                        <img
                            src={'/fac.png'}
                            height={150}
                            width={150}
                            className="p-2 px-3"
                            alt="facilities"
                        />

                    </div>
                    <div className="">
                        <h2 className="text-2xl font-medium">Facilities</h2>
                        <p className="text-sm py-2">Office access, cleaning, furniture, electrical/plumbing, repair & temperature</p>
                        <p className='text-base'></p>
                    </div>
                </a>

                <a
                    href={urls.technology}
                    target="_blank"
                    rel="noreferrer"
                    className="h-auto md:w-1/3 bg-gradient-to-r border border-gray-200 bg-white hover:shadow-md hover:bg-gray-100 hover:border-gray-400 p-2 py-4 px-4 flex max-w-96 rounded drop-shadow"
                >
                    <div className="flex items-center justify-center">
                        <img
                            src={'/tech.png'}
                            height={150}
                            width={150}
                            className="p-2 px-3"
                            alt="technology"
                        />
                    </div>
                    <div className="">
                        <h2 className="text-2xl font-medium">Technology</h2>
                        <p className="text-sm py-2">Open a ticket to report a problem or request access, software or equipment </p>
                        <p className=''>
                        </p>
                    </div>
                </a >
            </div >
        </>

    )
}

export default NewRequests;